import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateUiModule } from '@core/translation/translate-ui.module';

@Component({
  selector: 'mittanbud-success-contact',
  standalone: true,
  templateUrl: './mittanbud-success-contact.html',
  styleUrl: './mittanbud-success-contact.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateUiModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MittanbudSuccessContact {
  private _dialogRef: MatDialogRef<MittanbudSuccessContact> = inject(MatDialogRef);

  get dialogRef() {
    return this._dialogRef;
  }

  close(): void {
    this.dialogRef.close();
  }
}
